<template>
  <div class="platform-info-edit-wrp ft-12">
    <el-form class="form" :model="self_form" :rules="rules" ref="form" label-width="12%">
      <slot name="errMsg"></slot>
      <section>
        <div class="title ft-12">
          <span>基础信息</span>
        </div>
        <div class="conf">
          <el-form-item label="商品分类：" prop="categoryIds">
            <div class="category ft-12">
              <category-input ref="cinput" v-model="self_form.categoryIds" :platform="platform" @change="categoryIdsChange" />
            </div>
          </el-form-item>
         <el-form-item label="商品名称" prop="title">
            <el-input type="text" placeholder="请输入" 
              v-model="self_form.title" show-word-limit> 
              <el-tooltip slot="append" effect="dark" content="把单词首字母转为大写(点击生效)" placement="top">
                  <el-button icon="el-icon-daxiaoxie" @click="firstLetter(self_form.title)"></el-button>
              </el-tooltip>
               <!-- <span slot="suffix" style="margin-right: 6px;">{{titleLength}}/60</span> -->
            </el-input>
          </el-form-item>
          <el-form-item label="品牌" prop="brandId">
             <BrandIdBlock
                ref="brandIdBlockRef"
                v-model="self_form.brandList"
                :shopList="shopList"
                :categoryIds="self_form.categoryIds"
              />
              <div class="tips ft-12">
                <span>若未找到品牌，可前往商家后台品牌管理新增授权品牌</span>
              </div>
          </el-form-item>        
         <el-form-item label="商品属性">
            <Attributes 
              ref="attributes"
              :formdata="self_form" 
              :attrList="attrList"
              :attrListMap="attrListMap"
              :genericAttrList="genericAttrList" 
              :compositionAttrList="compositionAttrList" 
              :customAttributeCfg="customAttributeCfgMap"
              @getPropsList="getPropsList"
            />
         </el-form-item>
         <el-form-item label="商品描述">
            <el-input
              type="textarea"
              :rows="4"
              placeholder=""
              v-model="self_form._productDesc"
            >
            </el-input>
         </el-form-item>
        </div>
      </section>
      <section>
        <div class="title ft-12">
          <span>规格信息</span>
        </div>
        <div class="conf">
          <el-form-item label="商品规格" prop="skuAttrs">
            <FormItemSpecification
              ref="specificationRef"
              v-model="specifications"
              :saleAttrList="saleAttrList"
              :maxSpecNumLimit="3"
              :specSingleLimit="10"
              :changeToBase="changeToBase"
              :isCheckImg="true"
              @fieldChanged="specificationsFieldChanged"
            />
          </el-form-item>
          <el-form-item label="SKU信息" prop="skuAttrsDetail">
              <FormItemSkuList
                  :specifications="specifications"
                  :tableCols="skuTableCols"
                  :baseItemId="baseItemId"
                  :showBindSkuOuterId="false"
                  skuOuterIdKey="supplierSku"
                  v-model="skuList"
                  multipleSelection
                  @fieldChanged="specificationsFieldChanged"
                  @selection-change="handleSkuSelectionChanged"
              >
              </FormItemSkuList>
          </el-form-item>
          <el-form-item label="规格主图" prop="skcDetail">
            <MainSkuImg 
              ref="skcDetail"
              :formData="self_form" 
              :specifications="specifications" 
              :skcMainImg="skcMainImg" 
              @change="changeSkcMainImg" 
            />
          </el-form-item>
          <el-form-item label="详情图" prop="skcSiteDetailImage">
            <DetailImg 
              ref="skcSiteDetailImage"
              :formData="self_form" 
              :specifications="specifications" 
              :skcDetailImg="skcDetailImg" 
              :siteList="siteList"
              @change="changeSkcDetailImg"
            />
          </el-form-item>
          <el-form-item label="尺码表" prop="sizeChart">
            <SizeChart ref="sizeChartRef" :specifications="specifications" :sizeAttr="sizeAttrList" :sizeChart="sizeAttributeList" @change="changeSizeChart"  />
          </el-form-item>
        </div>
      </section>
      <!-- 上架设置 -->
      <section>
        <div class="title ft-12">
          <span>上架设置</span>
        </div>
        <div class="conf">
          <el-form-item 
            prop="_onShelfTimeType"
            label="上架设置:" 
            :rules="[{required: true, message: '请输入上架方式', trigger: 'blur'}]">
              <el-radio-group v-model="self_form._onShelfTimeType">
                  <el-radio :label="1">立即上架</el-radio>
                  <el-radio :label="2">定时上架</el-radio>
              </el-radio-group>
              <div>
                <el-date-picker
                  v-if="self_form._onShelfTimeType === 2"
                  v-model="self_form.onShelfTime.time"
                  width="250px"
                  type="datetime"
                  placeholder="选择日期时间"
                >
                </el-date-picker>
              </div>
          </el-form-item>
        </div>
      </section>
    </el-form>
  </div>
</template>
<script>
import {mapGetters} from 'vuex';
import '@/assets/css/prod.scss';
import ImgUpload from "@/components/Uploads/ImgUpload";
import MutiImgUpload from '@/components/Uploads/MutiImgUpload';
import VideoUpload from '@/components/Uploads/videoUpload'
import BatchEditImages from '@/components/prod/center/components/BatchEditImages.vue'
import GroupImagesList from '@/components/prod/center/BasicComps/GroupImages/list.vue'
import CategoryInput from '../PlatformCategoryInput/index.vue';
import BrandIdBlock from './BrandIdBlock.vue';
import Attributes from './Attributes';
import FormItemSpecification from './FormItemSpecification.vue';
import MainSkuImg from './MainSkuImg.vue';
import DetailImg from './DetailImg.vue';
import SizeChart from './SizeChart.vue';
import { last, get,cloneDeep } from 'lodash';

import RULES from './rules.js';
import { skuTableCols,ImageType } from './utils.js';
import { capitalizeFirstLetter } from '@/utils';

import { specification_mixin } from '../FormItemSpecification';
import { getCategoryProps,getSheinSiteList,getCustomAttributePermissionConfig } from '@/servers/prod/center/shein.js';
import { getDistributionConfig } from "@servers/prod/conf/index.js";
import validateMixin from '../validateMixin';
import shopListMixin from '../shopListMixin';
import dayjs from 'dayjs';

export default {
  mixins: [specification_mixin, validateMixin, shopListMixin],
  provide() {
    return {
      noSpPic: true,
      platform: "shein",
    }
  },
  inject: {
    isGroupPuhuo: { default: false },
  },
  components: {
    ImgUpload,
    MutiImgUpload,
    VideoUpload,
    BatchEditImages,
    GroupImagesList,
    CategoryInput,
    BrandIdBlock,
    Attributes,
    FormItemSpecification,
    MainSkuImg,
    DetailImg,
    SizeChart,
  },
  props: {
    form: {
      type: Object,
      default() {
        return {};
      },
    },
    rowData: {
      type: Object,
      default: () => ({})
    },
    baseItemId: [Number, String],
    changeToBase: Function,
  },
  data() {
    return {
      platform: 'shein',
      self_form: {},
      showGroupImages: true,
      rules: RULES(this),
      attrList:[],
      attrListMap:{},
      isOnshelf:1,
      operateRowData: [],
      skcMainImg:[],
      skcDetailImg:[],
      siteList:[],
      sizeAttributeList:[],
      customAttributeCfgMap:{},
      originalBrandList: null, // 原始品牌配置（用于保存时恢复未显示店铺的数据）
    };
  },
  watch: {
    form: {
      async handler(v) {
        // let _specifications = this.getSpecifications(v)
        let brandList = []
        let skcDetail = []
        let skcSiteDetailImage = []
        let itemPropValues = []
        let onShelfTime = {}
        let _sizeAttributeList = [];
        let productDesc = {};
        try{
          brandList = JSON.parse(v.brandList || '[]')
          itemPropValues = JSON.parse(v.itemPropValues || '[]')
          skcDetail = JSON.parse(v.skcDetail || '[]')
          skcSiteDetailImage = JSON.parse(v.skcSiteDetailImage || '[]')
          onShelfTime = JSON.parse(v.onShelfTime || '{}')
          productDesc = JSON.parse(v.productDesc || '{}')
          _sizeAttributeList = JSON.parse(v.sizeAttributeList || '[]')
        }catch(e){}
        // 保存原始品牌配置，用于保存时恢复未显示店铺的数据
        if (v.brandList) {
          this.originalBrandList = cloneDeep(brandList);
        }
        skcDetail.forEach(s => {
          let img1 = [];
          let img2 = [];
          let img3 = [];
          s.skcImageInfoList.forEach(i => {
            i.imageType = ImageType[i.imageType]
            if([1,2].includes(i.imageType)){
              img1.push(i.imageUrl)
            }else if(i.imageType === 5){
              img2.push(i.imageUrl)
            }else if(i.imageType === 6){
              img3.push(i.imageUrl)
            }
          })
          s.img1 = img1
          s.img2 = img2
          s.img3 = img3
        })
        this.skcMainImg = skcDetail;
        this.skcDetailImg = skcSiteDetailImage
        this.sizeAttributeList = _sizeAttributeList;
        const _skuList = v.skuList.map(item => {
          const _skuid = item.skuSpecifications.filter(sp => sp.valueKey).map(sp => sp.valueKey).join('-')
          let costInfo = [];
          try{
            costInfo = JSON.parse(item.costInfo || '[]')
          }catch(e){}
          const price = costInfo ? costInfo[0]?.costPrice : null
          return {
            ...item,
            price,
            _skuid,
          }
        })
        this.skuList = _.cloneDeep(_skuList);
        this.$set(this, 'self_form', {
          ...v,
          skuList:_skuList,
          brandList,
          itemPropValues,
          skcDetail,
          skcSiteDetailImage,
          // specifications:_specifications,
          onShelfTime:onShelfTime,
          _onShelfTimeType:Number((onShelfTime.type) || '1'),
          _productDesc:productDesc['zh-cn']
        });
        await this.getPropsList(); // 获取商品属性
        // this.$nextTick(() => {
        //   this.validPage();
        // });
      },
      immediate: true,
    },
    categoryId:{
      handler(v){
        if(v){
          this.getCustomAttribute();
        }
      },
      immediate: true,
    },
  },
  computed: {
    ...mapGetters(['shops_getCategoryPropShopId']),

    categoryId() {
      let categoryIds = this.self_form.categoryIds || [];
      return categoryIds.length ? categoryIds[categoryIds.length - 1] : '';
    },
    shopList() {
      return this.getShopList(this.platform);
    },
    shopId() {
      return this.$store.getters.shops_getCategoryPropShopId('shein')
    },
    // 普通属性
    genericAttrList(){
        let list = this.attrList.filter(item => item.attributeType === 4 || (item.attributeType === 3 && item.attributeMode !=4))
        // 排序 attributeMode为4的类型放在最后便于表单布局
        list.sort((a,b) => {
            return a.attributeMode === 4 ? 1 : -1
        })
        return list
    },
    // 成分属性
    compositionAttrList(){
        let list = this.attrList.filter(item => item.attributeType === 3 && item.attributeMode === 4)
        return list
    },
    // 尺寸属性
    sizeAttrList(){
        return this.attrList.filter(item => item.attributeType === 2)
    },
    // 销售属性
    saleAttrList(){
        let list = this.attrList.filter(item => item.attributeType === 1)
        return list;
    },
    skuTableCols() {
        const newSkuCols = cloneDeep(skuTableCols(this));
        return newSkuCols
    },
  },

  methods: {

    method_getFormData(cb) {
      const [specifications, skuList] = this.getSpecificationData()
      const itemPropValues = this.$refs.attributes.getAttr();
      return new Promise(async (resolve, reject) => {
        this.validPage().then(valid => {
          if (!valid) {
            this.$message.error('请完善表单');
            resolve(false);
            return false;
          }

          let _specifications = specifications.map(item => {
            let obj = {...item}
            let values = (obj.values || []).map(v => {
                let obj2 = {...v}
                // 保存的时候确保values有propId字段
                if(!obj2.propId){
                  obj2.propId = obj.propId
                }
                delete obj2.renderOptions
                delete obj2.renderType
                return obj2
            })

            delete obj.isMainSaleAttr
            delete obj.renderOptions
            delete obj.renderType
            return {
              ...obj,
              values
            }
          })
          let _formdata = JSON.parse(JSON.stringify(this.self_form));
          let lastLevelCateGory = this.$refs.cinput.method_getLastLevelCateGory() || {};
          _formdata.shopId = this.shopId;
          _formdata.productTypeId = lastLevelCateGory?.productTypeId;
          _formdata.categoryName = lastLevelCateGory?.name;
          _formdata.categoryId = lastLevelCateGory?.cid;
          _formdata.brandList = JSON.stringify(this.mergeHiddenShopData(cloneDeep(_formdata.brandList), this.originalBrandList, this.shopList));
          _formdata.itemPropValues = JSON.stringify(itemPropValues);
          _formdata.specifications = _specifications;
          _formdata.skcDetail = this.getSkcDetail(_formdata)
          _formdata.skcSiteDetailImage = this.getSkcSiteDetailImage(_formdata)
          _formdata.skuList = skuList.map(item => {
            let costInfo = [
                {
                  costPrice:item.price,
                  currency:'CNY',
                  // site:this.siteList[0]?.children[0]?.value || "shein-cn"
                }
            ]
            return {
              ...item,
              costInfo:JSON.stringify(costInfo),
            }
          })
          let onShelfTime = {
            type:_formdata._onShelfTimeType,
            time:''
          }
          // 商品描述
          if(_formdata._productDesc){
              _formdata.productDesc = JSON.stringify({'zh-cn':_formdata._productDesc})
          }
          
          // 尺码表
          let sizeChart  = this.$refs.sizeChartRef.getSizeChart(); 
          _formdata.sizeAttributeList = JSON.stringify(sizeChart);

          if(onShelfTime.type == 2){
            onShelfTime.time = dayjs(_formdata.onShelfTime.time).format('YYYY-MM-DD HH:mm:ss');
          }
          _formdata.onShelfTime = JSON.stringify(onShelfTime)
          // 提交表单
          console.log(_formdata, '-----_formdata----')
          // resolve(false);
          // return
          resolve(_formdata);
        });
      });
    },
    // 上传视频
    async handleVideo(value, type) {
      // type 0 删除 1 成功
      this.self_form.videoVo = type === 1 ? { ...value } : null;
      this.self_form.videoId = null;
      this.self_form.videoUrl = ''
    //   if(this.self_form.videoVo) {
    //     const videoId = await editCarouselVideo({
    //       carouselVideoVo: this.self_form.videoVo,
    //       baseItemId: this.self_form.baseItemId
    //     });
    //     this.self_form.videoUrl = value.originUrl
    //     this.self_form.videoId = videoId
    //   }
    },
    getSpecifications(formData){
        let _specifications = formData.specifications;
        let mainSaleAttrList = this.saleAttrList.filter(item => item.attributeLabel === 1) // 主销售属性
        mainSaleAttrList.sort((a,b) => a.attributeStatus === 3 ? -1 : 1); // 必填属性排在前面
        _specifications.forEach((item,index) => {
          let propId = item.propId || item.values[0].propId || null; // 每个规格值都有同一个规格id,所以规格id直接取第一个规格值的就行;
          item.renderType = 'select';
          item.propId = propId;
          item.isMainSaleAttr = index === 0;
          item.renderOptions = item.isMainSaleAttr ? mainSaleAttrList : this.saleAttrList;
          // 没有规格id的情况先做模糊匹配，模糊匹配不到再取第一个作为回显处理
          if(item.renderType === 'select' && !item.propId){
              let attr = item.renderOptions.find(i => item.name.includes(i.attributeName) || i.attributeName.includes(item.name))
              if(!attr){
                attr = item.renderOptions[0]; 
                if(index != 0){
                  // 排除已经选择的规格
                  let selectPropIds = _specifications.map(i => i.propId).filter(i => i)
                  for(let i = 0;i < item.renderOptions.length;i++){
                    let r = item.renderOptions[i]
                    if(!selectPropIds.includes(r.attributeId)){
                      attr = r
                      break;
                    }
                  }
                }

              }
              item.propId = attr.attributeId
          }
          item.values.forEach(v => {
            v.propId = propId
            v.propValueId = v.propValueId ? Number(v.propValueId) : null;
            if(Number.isNaN(v.propValueId)){
              v.propValueId = null;
            }
            let obj = item.renderOptions.find(r => r.attributeId === item.propId) || {}
            v.renderType = obj.attributeMode === 2 ? 'select' : 'input';
            v.renderOptions = obj.attributeValueInfoList
            // 没有规格值id的情况先做模糊匹配，模糊匹配不到再取第一个作为回显处理
            if(v.renderType === 'select' && !v.propValueId){
                let attr = null;
                // 排除已选中的规格值
                let selectPropValueIds = item.values.map(i => i.propValueId).filter(i => i)
                for(let i = 0;i < v.renderOptions.length;i++){
                  let p = v.renderOptions[i]
                  if(p.attributeValueId && p.attributeValue && !selectPropValueIds.includes(p.attributeValueId)){
                      // 没有规格值id的情况先做模糊匹配，模糊匹配不到再取第一个作为回显处理
                      if(v.value.includes(p.attributeValue) || p.attributeValue.includes(v.value)){
                        attr = p;
                        break;
                      }
                  }
                }
                if(attr){
                  v.propValueId = attr.attributeValueId
                }else{
                  v.propValueId = v.value
                }
            }
            if(v.renderType === 'input' && !v.propValueId){
              v.propValueId = v.value
            }

          })
        })
        _specifications.sort((a,b) => a.isMainSaleAttr ? -1 : 1)
        this.specifications = _specifications
        this.$set(this.self_form, 'specifications',_specifications);
        return _specifications
    },
    async valid_specifications() {
      return new Promise(async (resolve, reject) => {
          if (this.$refs.specificationRef) {
              let validSpecId = await this.$refs.specificationRef.validate();
              if (!validSpecId) {
                  resolve(false);
                  return;
              }
          }
          const specificationsValid = await this.validateSpecifications();
          this.specificationsValidResult = specificationsValid;
          if (specificationsValid !== true) {
              resolve(false);
              return;
          }
          resolve(true);
      });
    },
    getSkcSiteDetailImage(formData){
        let skcSiteDetailImage = []
        let skcSiteDetailImageMap = {}
        formData.skcSiteDetailImage.forEach(item => {
          let _id = item.attributeId + '_' + item.attributeValueId;
          let imgMap = {};
          let siteMap = {};
          (item.imageInfoList || []).forEach(img => {
            imgMap[img.imageUrl] = img;
          });
          (item.siteInfoList || []).forEach(site => {
            siteMap[site.mainSite+'_'+site.site] = site;
          });
          let newImgInfo = [];
          let newSiteInfo = [];
          (item.imgList || []).forEach(img => { 
            if(imgMap[img]){
              newImgInfo.push({...imgMap[img],imageSort:newImgInfo.length+1,})
            }else{
              newImgInfo.push({
                imageSort:newImgInfo.length+1,
                imageUrl:img
              })
            }
          });
          (item.site || []).forEach(s => { 
            let _id = s[0] + '_' + s[1]
            if(siteMap[_id]){
              newSiteInfo.push({...siteMap[_id]})
            }else{
              newSiteInfo.push({
                channel:'',
                mainSite:s[0],
                site:s[1]
              })
            }
          });
          if(newSiteInfo.length || newImgInfo.length){// 站点和图片都没有设置的话就不保存了
            if(skcSiteDetailImageMap[_id]){
              skcSiteDetailImageMap[_id].push(
                {
                  siteInfoList:newSiteInfo,
                  imageInfoList:newImgInfo
                }
              )
            }else{
              skcSiteDetailImageMap[_id] = [{
                siteInfoList:newSiteInfo,
                imageInfoList:newImgInfo
              }]
            }
          }
        })
        for(let key in skcSiteDetailImageMap){
          let arr = key.split('_');
          skcSiteDetailImage.push({
            attributeId:arr[0],
            attributeValueId:arr[1],
            siteDetailImageInfoList:skcSiteDetailImageMap[key].map(s => {
              return {
                imageInfoList:s.imageInfoList,
                siteInfoList:s.siteInfoList
              }
            })
          })
        }
        return JSON.stringify(skcSiteDetailImage)
    },
    getSkcDetail(formData){
      let skcDetail = formData.skcDetail.map(item => {
          let img1 = item.img1 || []
          let img2 = item.img2 || []
          let img3 = item.img3 || []
          if(img1.length || img2.length || img3.length){
            let oldImageMap = {};
            let newSkcImageInfoList = []
            item.skcImageInfoList.forEach(i => {
                oldImageMap[i.imageUrl] = i
            });
            img1.length && img1.forEach((url,index) => {
              if(oldImageMap[url]){
                newSkcImageInfoList.push({...oldImageMap[url],sort:newSkcImageInfoList.length+1})
              }else{
                newSkcImageInfoList.push({
                  imageType:index === 0 ? 1 : 2,
                  imageUrl:url,
                  sort:newSkcImageInfoList.length+1
                })
              }
            })
            img2.length && img2.forEach(url => {
              if(oldImageMap[url]){
                newSkcImageInfoList.push({...oldImageMap[url],sort:newSkcImageInfoList.length+1})
              }else{
                newSkcImageInfoList.push({
                  imageType:5,
                  imageUrl:url,
                  sort:newSkcImageInfoList.length+1
                })
              }
            })
            img3.length && img3.forEach(url => {
              if(oldImageMap[url]){
                newSkcImageInfoList.push({...oldImageMap[url],sort:newSkcImageInfoList.length+1})
              }else{
                newSkcImageInfoList.push({
                  imageType:6,
                  imageUrl:url,
                  sort:newSkcImageInfoList.length+1
                })
              }
            })
            item.skcImageInfoList = newSkcImageInfoList
          }
          delete item.img1
          delete item.img2
          delete item.img3
          return item;
      })
      return JSON.stringify(skcDetail)
    },
    // 获取配置
    async getConf() {
      const res = await getDistributionConfig({ shopType: "shein" });
      // 上架设置
      this.self_form.shelfState = this.form.shelfState ? this.form.shelfState : (res?.shelfState || 2);
    },
    handleSkuSelectionChanged(rowData) {
        this.operateRowData = rowData;
    },
    categoryIdsChange(categoryIds, lables,lastLevelCategory={}){
      let productTypeId = lastLevelCategory.productTypeId
      this.getPropsList(productTypeId)
    },
    // 获取商品属性
    async getPropsList(productTypeId,cb){
        let _productTypeId = this.form.productTypeId

        let data = {
            shopId:this.shopId,
            productTypeId: productTypeId || _productTypeId
        }
        if(!data.productTypeId){
          return
        }
        let res = await getCategoryProps(data)
        if(res.result === 1){
            let data = res.data[0];
            let list = data?.sheinAttributeValueInfo || [];
            this.attrList = list;
            let map = {};
            list.forEach(item => {
              map[item.attributeId] = item
            })
            this.attrListMap = map
            let _specifications = this.getSpecifications(this.self_form)
            cb && cb()
        }
    },
    //查询是否支持自定义属性值
    async getCustomAttribute(){
      let data = {
          shopId:this.shopId,
          categoryId: this.categoryId 
      }
      if(!data.categoryId){
        return
      }
      let res = await getCustomAttributePermissionConfig(data)
      if(res.result === 1){
          let data = res.data;
          let map = {}
          data.forEach(item => {
            map[item.attributeId] = !!item.hasPermission;
          });
          this.$set(this,'customAttributeCfgMap',map)
      }
    },
    // 获取站点
    async getSiteList(){
      if(!this.shopId){
        return
      }
        let res = await getSheinSiteList({shopId:this.shopId})
        if(res.result ===1 ){
            let list = []
            list = (res.data || []).map(item => {
                return {
                    value: item.mainSite,
                    label: item.mainSiteName,
                    children:(item.subSiteList || []).map(i => {
                        return {
                            value: i.siteAbbr,
                            label: i.siteName,
                            currency:i.currency
                        }
                    })
                }
            })
            this.siteList = list; 
        }
    },
    changeSkcMainImg(data){
      this.skcMainImg = data;
      this.self_form.skcDetail = data
    },
    changeSkcDetailImg(data){
      this.skcDetailImg = data;
      this.self_form.skcSiteDetailImage = data
    },
    changeSizeChart(data){
      this.$set(this.self_form, 'sizeChart',data)
    },
    firstLetter(str){
      let title = capitalizeFirstLetter(str)
      this.self_form.title = title
    },
  },
  mounted() {
    this.getConf();
    this.getSiteList();
  },
};
</script>

<style lang="scss" scope>
a{
  color:#6189f5;
  text-decoration: none;
}
.no-specifications{
  display: flex;
  justify-content: center;
  align-items: center;
  margin:20px;
  color:#ccc;
}
.is-disabled {
  pointer-events: none;
  opacity: 0.6;
  * {
    pointer-events: none;
  }
}
</style>
  